<div class="container-fluid p-0 new-product-main">
  <div class="mt-2">
    <form class="" name="signupForm" [formGroup]="signupForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="card">
        <div class="card-body">
              <div class="font-size-20 fw-700 mb-3">
                <ng-container>General Information</ng-container>
              </div>
            <div formGroupName="userDetails">
              <div class="row">
                <div class="col-md-7">
                  <div class="form-group mb-3">
                    <label for="name">First Name</label>
                    <div class="col-sm-7 sm-mt-0 p-0">
                      <input type="text" formControlName="firstName" class="form-control" [ngClass]="{
                        'is-invalid': (submitted || userDetails.firstName.touched) && userDetails.firstName.errors
                      }" id="firstName" placeholder="Enter First Name" />
                    </div>
                    <div *ngIf="(submitted || userDetails.firstName.touched) && userDetails.firstName.errors"
                      class="invalid-feedback">
                      <div *ngIf="(submitted || userDetails.firstName.touched) && (userDetails.firstName.errors?.required || userDetails.firstName.errors?.whiteSpace)">
                        First Name is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="form-group mb-3">
                    <label for="name">Last Name</label>
                    <div class="col-sm-7 sm-mt-0 p-0">
                      <input type="text" formControlName="lastName" class="form-control" [ngClass]="{
                        'is-invalid': (submitted || userDetails.lastName.touched) && userDetails.lastName.errors
                      }" id="lastName" placeholder="Enter Last Name" />
                    </div>
                    <div *ngIf="(submitted || userDetails.lastName.touched) && userDetails.lastName.errors"
                      class="invalid-feedback">
                      <div
                      *ngIf="(submitted || userDetails.lastName.touched) && (userDetails.lastName.errors?.required || userDetails.lastName.errors?.whiteSpace)">
                         LastName is required
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-7">
                  <div class="form-group mb-3">
                    <label for="email">Email</label>
                    <div class="col-sm-7 sm-mt-0 p-0">
                      <input type="email" [(ngModel)]="signupForm.value.userDetails.userEmail"
                      (ngModelChange)='validateEmail()' (blur)="checkEmailInUse()" autocomplete="off"
                      formControlName="userEmail" class="form-control" [ngClass]="{
                          'is-invalid': (submitted || userDetails.userEmail.touched) && userDetails.userEmail.errors
                        }" id="userEmail" placeholder="Email" />
                    </div>
    
                    <div *ngIf="(submitted || userDetails.userEmail.touched) && userDetails.userEmail.errors"
                      class="invalid-feedback">
                      <div *ngIf="
                            (submitted || userDetails.userEmail.touched) && userDetails.userEmail.errors?.required
                          ">
                        Email is required
                      </div>
                      <div *ngIf="submitted && userDetails.userEmail.errors?.email">
                        Email must be a valid email address
                      </div>
                    </div>
                  </div>
                </div>
<div class="col-md-7">
  <div class="form-group mb-3">
    <label for="userPassword">Password</label>
    <div class="col-sm-7 sm-mt-0 p-0 ">
      <div class="d-flex number-input position-relative">
        <input [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                      formControlName="userPassword" class="form-control pwd-in" [ngClass]="{
                        'is-invalid': (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors
                      }" id="userPassword" placeholder="Password" />
        <button class="btn btn-light ms-0 eyebtn"
        [ngClass]="{ 'is-invalid': submitted && userDetails.userPassword.errors }" type="button"
        id="password-addon" (click)="togglePassword()"><p *ngIf="!showPassword" style="margin: auto;"><i class="fa-light fa-eye"></i></p>
        <p *ngIf="showPassword" style="margin: auto;"><i class="fa-light fa-eye-slash"></i></p></button>
      </div>
      <div *ngIf="(submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors"
      class="invalid-feedback">
      <div *ngIf="
          (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors?.required
        ">
        Password is required
      </div>
      <div
        *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required && userDetails.userPassword.errors.uppercase">
        Password should have atleast one uppercase character
      </div>
      <div
        *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.lowercase">
        Password should have atleast one lowercase character
      </div>
      <div
        *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.oneNumber">
        Password should have atleast one number and one symbol
      </div>
      <div
        *ngIf="(submitted || userDetails.userPassword.touched) && (userDetails.userPassword.errors?.minLength || userDetails.userPassword.errors?.maxLength)">
        Password should be minimum 8 and maximum 27 characters
      </div>
    </div>
    </div>
  </div>
</div>
<div class="col-md-7">   <div class="form-group mb-3">
  <label for="password2">Confirm Password</label>
  <div class="col-sm-7 sm-mt-0 p-0 ">
    <div class="d-flex number-input position-relative">
      <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="cPassword"
      class="form-control pwd-in" [ngClass]="{
      'is-invalid':
        (submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors
    }" id="password2" placeholder="Password" />


       <button class="btn btn-light ms-0 eyebtn"
      [ngClass]="{ 'is-invalid': submitted && userDetails.userPassword.errors }" type="button"
      id="confirm-password-addon" (click)="toggleConFirmPassword()"><p *ngIf="!showConfirmPassword" style="margin: auto;"><i class="fa-light fa-eye"></i></p>
      <p *ngIf="showConfirmPassword" style="margin: auto;"><i class="fa-light fa-eye-slash"></i></p></button>
    </div>
    <div *ngIf="(submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors"
    class="invalid-feedback">
    <div *ngIf="
          (submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors?.required
        ">
      Confirm Password is required
    </div>
    <div
      *ngIf="(submitted || userDetails.cPassword.touched) && !userDetails.cPassword.errors?.required && userDetails.cPassword.errors.mustMatch">
      Password and confirm not match
    </div>
  </div>
  </div>
</div></div>
<div class="col-md-7">  <div class="form-group mb-3">
  <div>
    <label class="form-label" for="phone">Phone Number</label>
  </div>
  <div class="col-sm-7 p-0 sm-mt-0">
    <ngx-intl-tel-input class="text-start number-fild"
      [cssClass]="{ 'form-control' : 1, 'is-invalid': (submitted || userDetails.phone.touched) && userDetails.phone.errors }"
      [preferredCountries]="preferredCountries"
      [enableAutoCountrySelect]="true"
      [enablePlaceholder]="true"
      [searchCountryFlag]="true"
      [searchCountryField]="[
          SearchCountryField?.Iso2,
          SearchCountryField.Name
        ]" [selectFirstCountry]="true"
        [customPlaceholder] =placeholder
        [separateDialCode]="true"
        [selectedCountryISO]=currentCountryISO
      [maxLength]="10"
      [phoneValidation]="true"
      name="phone"
      formControlName="phone"
      (countryChange)="onCountryChange($event)">
    </ngx-intl-tel-input>
  </div>
  <!-- *ngIf="(submitted || userDetails.phone.touched) && userDetails.phone.errors" -->
  <div
    >
    <div class="input-invalid-error" *ngIf="
          (submitted || userDetails.phone.touched) && userDetails.phone.errors?.required
        ">
      Phone number is required
    </div>
    <div
  class="form-text text-danger"
  *ngIf="
          (submitted || userDetails.phone.touched) && userDetails.phone.errors
        "
>
  Invalid Phone Number
</div>
  </div>
</div></div>


<div class="col-md-7">
  <div class="form-group mb-3">
    <label for="countryControlSelect">Country</label>
    <!-- <app-list-of-countries [userDetailsForm]="signupForm.get('userDetails')"
    [submitted]="submitted" [Send_Contry_Code]="Country_Code_change">
    </app-list-of-countries> -->
    <div class="col-sm-7 p-0 sm-mt-0">
    <app-merchant-list-of-countries [userDetailsForm]="signupForm.get('userDetails')"
    [submitted]="submitted" [Send_Contry_Code]="Country_Code_change">
    </app-merchant-list-of-countries>
    </div>

    <div>
      <div class="input-invalid-error" class="text-danger"
      *ngIf="(submitted || userDetails.country.touched)
      && userDetails.country.errors || userDetails.country.value == 'null'">
        Country is required
      </div>
      <!-- *ngIf="(submitted || userDetails.country.touched) && userDetails.country.errors?.required" -->
    </div>
  </div>
</div>
 </div>

              

              <!-- <div class="form-group mb-3">
                <label for="userPassword">Password</label>
                <div class="input-group auth-pass-inputgroup">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                    formControlName="userPassword" class="form-control pwd-in" [ngClass]="{
                      'is-invalid': (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors
                    }" id="userPassword" placeholder="Password" />
                  </div>


                  <button class="btn btn-light ms-0 eyebtn"
                    [ngClass]="{ 'is-invalid': submitted && userDetails.userPassword.errors }" type="button"
                    id="password-addon" (click)="togglePassword()"><p *ngIf="!showPassword" style="margin: auto;"><i class="fa-light fa-eye"></i></p>
                    <p *ngIf="showPassword" style="margin: auto;"><i class="fa-light fa-eye-slash"></i></p></button>
                 
                 
                    <div *ngIf="(submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors"
                    class="invalid-feedback">
                    <div *ngIf="
                        (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors?.required
                      ">
                      Password is required
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required && userDetails.userPassword.errors.uppercase">
                      Password should have atleast one uppercase character
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.lowercase">
                      Password should have atleast one lowercase character
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.oneNumber">
                      Password should have atleast one number and one symbol
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && (userDetails.userPassword.errors?.minLength || userDetails.userPassword.errors?.maxLength)">
                      Password should be minimum 8 and maximum 27 characters
                    </div>
                  </div>
                </div>
              </div> -->

 <!-- <div class="form-group mb-3">
                <label for="userPassword">Password</label>
                <div class="input-group auth-pass-inputgroup">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input [type]="showPassword ? 'text' : 'password'" autocomplete="off"
                    formControlName="userPassword" class="form-control pwd-in" [ngClass]="{
                      'is-invalid': (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors
                    }" id="userPassword" placeholder="Password" />
                  </div>


                  <button class="btn btn-light ms-0 eyebtn"
                    [ngClass]="{ 'is-invalid': submitted && userDetails.userPassword.errors }" type="button"
                    id="password-addon" (click)="togglePassword()"><p *ngIf="!showPassword" style="margin: auto;"><i class="fa-light fa-eye"></i></p>
                    <p *ngIf="showPassword" style="margin: auto;"><i class="fa-light fa-eye-slash"></i></p></button>
                 
                 
                    <div *ngIf="(submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors"
                    class="invalid-feedback">
                    <div *ngIf="
                        (submitted || userDetails.userPassword.touched) && userDetails.userPassword.errors?.required
                      ">
                      Password is required
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required && userDetails.userPassword.errors.uppercase">
                      Password should have atleast one uppercase character
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.lowercase">
                      Password should have atleast one lowercase character
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && !userDetails.userPassword.errors?.required  && userDetails.userPassword.errors.oneNumber">
                      Password should have atleast one number and one symbol
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.userPassword.touched) && (userDetails.userPassword.errors?.minLength || userDetails.userPassword.errors?.maxLength)">
                      Password should be minimum 8 and maximum 27 characters
                    </div>
                  </div>
                </div>
              </div> -->

              <!-- <div class="form-group mb-3">
                <label for="password2">Confirm Password</label>
                <div class="input-group auth-pass-inputgroup">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="cPassword"
                    class="form-control" [ngClass]="{
                    'is-invalid':
                      (submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors
                  }" id="password2" placeholder="Password" />
                  </div>

                  <button class="btn btn-light ms-0 eyebtn"
                    [ngClass]="{ 'is-invalid': submitted && userDetails.userPassword.errors }" type="button"
                    id="confirm-password-addon" (click)="toggleConFirmPassword()"><p *ngIf="!showConfirmPassword" style="margin: auto;"><i class="fa-light fa-eye"></i></p>
                    <p *ngIf="showConfirmPassword" style="margin: auto;"><i class="fa-light fa-eye-slash"></i></p></button>
                  <div *ngIf="(submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors"
                    class="invalid-feedback">
                    <div *ngIf="
                          (submitted || userDetails.cPassword.touched) && userDetails.cPassword.errors?.required
                        ">
                      Confirm Password is required
                    </div>
                    <div
                      *ngIf="(submitted || userDetails.cPassword.touched) && !userDetails.cPassword.errors?.required && userDetails.cPassword.errors.mustMatch">
                      Password and confirm not match
                    </div>
                  </div>
                </div>
              </div> -->

              <div>
              </div>
            </div>
        </div>
      </div>
      <!-- end of first section of form-->

      <div class="card">
        <div class="card-body">
          <div class="font-size-20 fw-700 mb-3">
            <ng-container>Restaurant Information</ng-container>
          </div>
          <div formGroupName="restaurantDetails">
            <div class="row">
              <div class="col-md-7"><div class="form-group mb-3">
                <label for="restaurantName">Restaurant Name</label>
                <div class="col-sm-7 sm-mt-0 p-0">
                  <input type="text" formControlName="restaurantName" class="form-control" [ngClass]="{
                    'is-invalid': (submitted || restaurantDetails.restaurantName.touched) && restaurantDetails.restaurantName.errors
                  }" id="name" placeholder="Restaurant Name" />
                </div>
                <div
                  *ngIf="(submitted || restaurantDetails.restaurantName.touched) && restaurantDetails.restaurantName.errors"
                  class="invalid-feedback">
                  <div *ngIf="restaurantDetails.restaurantName.errors.required">
                    Restaurant Name is required
                  </div>
                </div>
              </div></div>
            </div>
            <div class="col-md-7">

            <div class="form-group mb-3">
              <label for="restaurantType">Restaurant Type</label>
              <div class="col-sm-7 sm-mt-0 p-0">
                <select class="form-control" formControlName="restaurantType"
                [ngClass]="{
                  'is-invalid': (submitted || restaurantDetails.restaurantType.touched) && restaurantDetails.restaurantType.errors}">
                <option [value]="null" disabled>Select Restaurant Type</option>
                <option value="Restaurant System" class="ng-star-inserted">Restaurant System</option>
                <option value="Bar" class="ng-star-inserted">Bar</option>
                <option value="Quick Service" class="ng-star-inserted">Quick Service</option>
                <option value="Nightclub" class="ng-star-inserted">Nightclub</option>
                <option value="Pizza" class="ng-star-inserted">Pizza</option>
                <option value="Fine Dining" class="ng-star-inserted">Fine Dining</option>
                <option value="Casual Dining" class="ng-star-inserted">Casual Dining</option>
                <option value="Deli" class="ng-star-inserted">Deli</option>
                <option value="Brewery" class="ng-star-inserted">Brewery</option>
                <option value="Drive-through" class="ng-star-inserted">Drive-through</option>
                <option value="Winery" class="ng-star-inserted">Winery</option>
                <option value="Bakery" class="ng-star-inserted">Bakery</option>
                <option value="Cafe Restaurant" class="ng-star-inserted">Cafe Restaurant</option>
              </select>
              </div>

              <div
                *ngIf="(submitted || restaurantDetails.restaurantType.touched) && restaurantDetails.restaurantType.errors"
                class="invalid-feedback">
                <div *ngIf="restaurantDetails.restaurantType.errors.required">
                  Restaurant type is required
                </div>
              </div>
            </div>
            </div>
<div class="col-md-7">
            <div id="addressForm" class="form-group">
              <label for="">Restaurant Address</label>
              <div class="addForm mb-3">
                <div class="col-sm-7 sm-mt-0 p-0">
                  <input  type="text" class="form-control addForm" id="search"
                  placeholder="Address 1" formControlName="addressOne" autocorrect="off" autocapitalize="off"
                  spellcheck="off"
                  #search
                  [ngClass]="{
                      'is-invalid': (submitted || restaurantDetails.addressOne.touched) && restaurantDetails.addressOne.errors}" />
                </div>

                <div
                  *ngIf="(submitted || restaurantDetails.addressOne.touched) && restaurantDetails.addressOne.errors"
                  class="invalid-feedback">
                  <div *ngIf="restaurantDetails.addressOne.errors.required">
                    Restaurant Address1 is required
                  </div>
                </div>
              </div>
              <div class="addForm mb-3">
                <div class="col-sm-7 sm-mt-0 p-0">
                  <input type="street" class="form-control" id="autocomplete" placeholder="Address 2"
                  formControlName="addressTwo" />
                </div>
              </div>

              <!-- <div class="addForm row mb-3"> -->
                <div class="addForm mb-3">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input type="city" class="form-control" id="inputCity" placeholder="City"
                    formControlName="city"
                    [ngClass]="{
                        'is-invalid': (submitted || restaurantDetails.city.touched) && restaurantDetails.city.errors}">
                  </div>
                  <div *ngIf="(submitted || restaurantDetails.city.touched) && restaurantDetails.city.errors"
                    class="invalid-feedback">
                    <div *ngIf="restaurantDetails.city.errors.required">
                      City is required
                    </div>
                  </div>
                </div>
                <div class="addForm mb-3">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input type="state" class="form-control" id="inputState" placeholder="State"
                    formControlName="state"
                    [ngClass]="{
                        'is-invalid': (submitted || restaurantDetails.state.touched) && restaurantDetails.state.errors}">
                  </div>
                  <div *ngIf="(submitted || restaurantDetails.state.touched) && restaurantDetails.state.errors"
                    class="invalid-feedback">
                    <div *ngIf="restaurantDetails.state.errors.required">
                      State is required
                    </div>
                  </div>
                </div>

                <div class="addForm mb-3">
                  <div class="col-sm-7 sm-mt-0 p-0">
                    <input type="zip" class="form-control" id="inputZip" placeholder="Zip Code"
                    formControlName="zipcode" OnlyNumber="true" (keypress)="($event.charCode >= 48 && $event.charCode < 58)"
                    [ngClass]="{
                        'is-invalid': (submitted || restaurantDetails.zipcode.touched) && restaurantDetails.zipcode.errors}">
                  </div>
                  <div
                    *ngIf="(submitted || restaurantDetails.zipcode.touched) && restaurantDetails.zipcode.errors"
                    class="invalid-feedback">
                    <div *ngIf="restaurantDetails.zipcode.errors.required">
                      Zip Code is required
                    </div>
                  </div>
                </div>
            </div>
            </div>
            <div class="col-md-7">
            <div class="form-check-pink form-check">
              <div class="col-sm-7 sm-mt-0 p-0">
                <input type="checkbox" class="form-check-input" id="sellerAgreement"
                formControlName="sellerAgreement" />
              </div>
              <label class="form-check-label" for="sellerAgreement">
                <span class="pl-0" for="sellerAgreement">eatOS's
                  <b><a href="https://www.eatos.com/legal-terms/" target="_blank" class="text-black">Seller
                      Agreement</a></b>
                  and <b><a href="https://www.eatos.com/e-sign-consent/" target="_blank" class="text-black">e-Sign Consent</a></b></span>
              </label>
            </div>
          </div>
            <div *ngIf="submitted && restaurantDetails.sellerAgreement.errors" class="input-invalid-error">
              You have to accept the sellerAgreement
            </div>
          </div>
        </div>
      </div>

      <!-- Ends Section Two -->
      <!-- <div *ngIf="page == 3">
        <ng-container>
          <label for="email" class="form-label">Email Address</label>
          <div class="form-group d-flex justify-content-sb align-item-center  mb-3">
            <div class="form-control pointer-event-none">
              {{signupForm.value.userDetails.userEmail}}
            </div>
          </div>
        </ng-container>
      </div> -->
      <!-- <div *ngIf="page == 4">
        <div class="form-group mb-0">
          <ng-otp-input #ngOtpInputTwo class="nor" (onInputChange)="changeOtp($event)" [config]="configTwo">
          </ng-otp-input>
        </div>
        <div class="my-1">
          <div class="error-msg d-flex justify-content-center align-item-center" *ngIf="otpErrorMsg">
            <img src="../../../../assets/images/error-icon.svg" />
            <span class="text-danger">Please enter the right code!</span>
          </div>
        </div>
        <div class="my-3" *ngIf="countdown > 0 && disabledResendOtp">
          <h4>
            <p class="text-lighter text-center">{{ countdownDisplay }} </p>
          </h4>
        </div>
      </div> -->
      <div class="form-btn">
        <!-- <button *ngIf="page == 1" (click)="onNextPage()"
          class="sec-btn next-theme font-size-18 fw-700 text-dark-black w-100">
          <span class="text">Next</span>
        </button> -->
        <!-- <div class="my-3" *ngIf="showCaptcha"> -->
          <!-- <app-captcha-check
            class="form-control p-0 captch-box-shadow"
            [config]="captchaConfig"
            (closeSecurityModalref)="closeSecurityCheckModal($event)"
            (captchaVerified)="onCaptchaVerified()">
          </app-captcha-check> -->
          <!-- <app-merchant-captcha-check
            class="form-control p-0 captch-box-shadow"
            [config]="captchaConfig"
            (closeSecurityModalref)="closeSecurityCheckModal($event)"
            (captchaVerified)="onCaptchaVerified()">
          </app-merchant-captcha-check> -->
        <!-- </div> -->
        <button
          *ngIf="!showLoader"
          (click)="onClickSignUp()"
          [disabled]="!signupForm.valid"
          class="save-btn"
          [ngClass]="showLoader ? 'pointer-event-none':''"
        >
          <span class="text">On Board</span>
        </button>
        <button  class="save-btn" type="button" disabled
          *ngIf="showLoader">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="pl-2">&nbsp;&nbsp;Loading...</span>
        </button>
      </div>
      <!-- <div class="mt-3" *ngIf="!showLoader">
        <button *ngIf="page == 3" class="sec-btn font-size-18 fw-700 w-100" (click)="sendCode()">
          <span class="text">Send Code</span>
        </button>
      </div> -->
      <!-- <div class="mt-3" *ngIf="!showLoader">
        <button *ngIf="page == 4 && !disabledResendOtp && countdown == 0"
          class="sec-btn font-size-18 fw-700 w-100" (click)="resendOTPCode()">
          <span class="text">Resend OTP</span>
        </button>
        <button *ngIf="page == 4 && !disabledConfirmBtn && countdown > 0" [disabled]="!enableConfirm"
          class="sec-btn font-size-18 fw-700 w-100" (click)="verifyOTPCode()">
          <span class="text">Confirm OTP</span>
        </button>
      </div> -->
      <!-- <div class="mt-3 d-grid" *ngIf="showLoader">
        <button class="sec-btn font-size-18 fw-700 w-100" type="button" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="pl-2">&nbsp;&nbsp;Loading...</span>
        </button>
      </div> -->
    </form>
    <!-- <div class="text-center" *ngIf="page != 3 && page != 4">
      <div class="mt-4 text-center">
        <p class="mb-0"> Have an account? <a href="javascript: void(0);"
            [ngClass]="showLoader ? 'pointer-event-none':''" (click)="goToLoginPage()"
            class="text-dark-black"><span class="fw-bold">Sign in</span></a></p>
      </div>
    </div> -->
  </div>
</div>
